import ENV from '@/constants/env'

export const buildImageUrl = (src?: string | null): string => {
    if (!src) {
        return `${ENV.fileHost}/img/profiles/generic/gray.png`
    }

    if (src.startsWith('http')) {
        return src
    }

    // If src already starts with '/', don't add another one
    const cleanSrc = src.startsWith('/') ? src.slice(1) : src
    return `${ENV.fileHost}/${cleanSrc}`
}
